var Layout = require("enyo/Layout"),
    kind   = require("enyo/kind");


module.exports = kind(/** @lends  app.SearchPage.FilterBarLayout.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.FilterBarLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var that                 = this,
            container            = this.container,
            containerNode        = container.hasNode(),
            $inlineMenu          = container.$.inlineMenu,
            $dropdownMenu        = container.$.dropdownMenu,
            $inlineMenuButtons   = $inlineMenu.children,
            $dropdownMenuButtons = $dropdownMenu.$.repeater.children,
            availableWidth,
            inlineMenuWidth,
            numInlineItems;

        if (!containerNode
            && $inlineMenuButtons.length > 0
            && $dropdownMenuButtons.length > 0) {
            return;
        }

        // Visually hide menus to prevent visual flashes of partial layout
        this.visuallyHideControl($inlineMenu);
        this.visuallyHideControl($dropdownMenu);

        // Starting point: Show all menu items.
        $inlineMenuButtons.forEach(function($item) {
            that.showControl($item);
        });
        $dropdownMenuButtons.forEach(function($item) {
            that.showControl($item);
        });

        // Determine available width
        availableWidth  = container.$.wrapper.getBounds().width;
        inlineMenuWidth = $inlineMenu.getBounds().width;

        // Inline menu fits, no dropdown needed.
        if (inlineMenuWidth <= availableWidth) {
            // Hide dropdown menu
            this.hideControl($dropdownMenu);

            // Show inline menu
            this.showControl($inlineMenu);

            return;
        }

        // Some items might fit in the inline menu, whatever doesn't fit goes into the dropdown.
        $dropdownMenu.set("listAll", false);
        availableWidth  -= $dropdownMenu.getBounds().width;
        inlineMenuWidth = 0;
        numInlineItems  = 0;

        $inlineMenuButtons.forEach(function($item, index) {
            var width;

            width = $item.getBounds().width;

            // Item fits in inline menu. Hide twin in dropdown menu
            if (width <= availableWidth) {
                numInlineItems++;
                $dropdownMenuButtons[index] && $dropdownMenuButtons[index].hide();
                availableWidth  -= width;
                inlineMenuWidth += width;
            }

            // Item doesn't fit in inline menu. Hide it and let the twin in the dropdown menu do the work.
            else {
                $item.hide();
                availableWidth = 0;
            }
        });


        // Use dropdown only.
        if (numInlineItems === 0) {
            this.hideControl($inlineMenu);

            $dropdownMenu.set("listAll", true);
            $dropdownMenu.applyStyle("left", "0px");
            this.showControl($dropdownMenu);

            return;
        }

        // Use dropdown next to inline menu
        else {
            $dropdownMenu.applyStyle("left", inlineMenuWidth + "px");
        }


        // Visually reveal the menus
        this.showControl($inlineMenu);
        this.showControl($dropdownMenu);
    },

    /**
     * Fully hides the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    hideControl: function(control) {
        control.hide();
    },

    /**
     * Ensures the control is displayed in the DOM. It might still be visually
     * hidden, but it will have a working box-model.
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    visuallyHideControl: function(control) {
        // Sometimes Chrome doesn't properly update dimensions when using
        // visibility hidden, so we make sure the control is just *slightly*
        // visible. This forces Chrome to calculate it's properties correctly.
        control.applyStyle("opacity", 0.001);
        control.show();
    },

    /**
     * Fully reveals the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    showControl: function(control) {
        control.applyStyle("opacity", 1);
        control.show();
    }
});
